import { browserHistory } from '@client/router/compat';

/**
 * Search param carrying the name of a program that was just saved. When
 * present on the offers page, the subscription content table accordion opens
 * and scrolls to the matching program row.
 */
export const OFFERS_SCROLL_TO_PROGRAM_PARAM = 'contentProgram';

export const getSearchParam = (key: string): string | null =>
  new URLSearchParams(window.location.search).get(key);

export const removeSearchParam = (key: string): void => {
  const url = new URL(window.location.href);
  url.searchParams.delete(key);
  browserHistory.replace(`${url.pathname}${url.search}${url.hash}`);
};
